module.exports = __webpack_public_path__ + "img/main_m.4067deb6.jpg";